import React from 'react'
import styled from 'styled-components'
import { Text, getPaletteColor, Box } from 'pcln-design-system'
import airTheme from '../AirThemeProvider/airTheme'

import ExDealsLogo from './images/ExDealsLogoSVG'
import LastMinuteBlueSVG from './images/LastMinuteBlueSVG'
import AirDiscountSVG from './images/AirDiscountSVG'
import TicketSVG from './images/TicketSVG'

const Wrapper = styled(Box)`
  max-width: 650px;
`

const LastMinuteSvg = styled.div`
  svg {
    height: 65px;
    width: 65px;
  }
`

const AirDiscountSvgWrapper = styled.div`
  svg {
    height: 72px;
    width: 82px;
  }
`

const TicketSvgWrapper = styled.div`
  svg {
    height: 65px;
    width: 65px;
  }
`

const ExDealLogoWrap = styled.span`
  padding-left: 4px;

  & > * {
    margin-bottom: -1px;
  }
`

const InfoGraphic = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: 0 auto;

  ${airTheme.flyQueries.tabletlg} {
    width: 80%;
  }
`

const TutorialContent = styled.div`
  ${airTheme.flyQueries.tablet} {
    display: flex;
    margin: 0 auto;
    width: 100%;
  }
`

const TutorialParagraph = styled(Text.p)`
  line-height: 1.43;
  margin-top: 15px;
  display: block;

  ${airTheme.flyQueries.tablet} {
    flex: 1 1 auto;
    margin-right: 34px;
    text-align: center;
  }

  &:last-child {
    margin-right: 0;
  }
`

const TutorialAirlines = styled.div`
  display: flex;
  width: 278px;
  margin: 25px auto 0 auto;
  align-items: center;
  flex-flow: row wrap;
  justify-content: space-around;

  ${airTheme.flyQueries.tabletlg} {
    flex-flow: row nowrap;
    width: 95%;
  }
`

const LogosHeader = styled(Text.span)`
  padding-bottom: 7px;
  text-align: center;

  ${airTheme.flyQueries.tabletlg} {
    margin-top: 0;
    padding-bottom: 0;
    flex: 7;
    margin-right: 18px;
  }
`

const Disclaimer = styled(Text)`
  line-height: 1.33;
  padding: 14px 5px 0 5px;
  text-align: center;

  ${airTheme.flyQueries.mobile} {
    margin: 0 auto;
    width: 170px;
  }

  ${airTheme.flyQueries.tablet} {
    padding: 14px 0 0 0;
    width: 100%;
  }
`

const AirlineLogoWrap = styled.span`
  img {
    display: block;
    max-width: 25px;
    max-height: 20px;
    width: auto;
    height: auto;
  }

  ${airTheme.flyQueries.tabletlg} {
    display: flex;
    flex: 1;
    margin: 0 6px;
  }
`

const SvgDivider = styled.span`
  border: 1px solid ${getPaletteColor('alert.base')};
  flex: 1;
  margin: 0 5px 0 -5px;
  max-width: 173px;

  &:first-of-type {
    margin: 0 5px 0 5px;
  }
`

const imgPath = 'https://s1.pclncdn.com/design-assets/fly/carrier-logos/'

export default function ExpressDealTutorial() {
  return (
    <Wrapper id={'tutorial-overlay'} pt={4} pb={4}>
      <Text fontSize={3} textAlign={'center'} mb={3} regular>
        What are
        <ExDealLogoWrap>
          <ExDealsLogo />
        </ExDealLogoWrap>
        ?
      </Text>

      <InfoGraphic>
        <LastMinuteSvg>
          <LastMinuteBlueSVG />
        </LastMinuteSvg>
        <SvgDivider />
        <AirDiscountSvgWrapper>
          <AirDiscountSVG />
        </AirDiscountSvgWrapper>
        <SvgDivider />
        <TicketSvgWrapper>
          <TicketSVG />
        </TicketSvgWrapper>
      </InfoGraphic>

      <TutorialContent>
        <TutorialParagraph regular>
          Going on a last-minute trip? Flexible on travel times? Save up to 40% with an Express Deal!
        </TutorialParagraph>
        <TutorialParagraph regular>
          Airlines give big discounts for last-minute travel, but they keep some of the flight details hidden.
        </TutorialParagraph>
        <TutorialParagraph regular>
          You’ll get your full itinerary right after booking—along with awesome savings worth bragging about!
        </TutorialParagraph>
      </TutorialContent>

      <TutorialAirlines>
        <LogosHeader bold>Here are examples of our partner airlines:</LogosHeader>
        <AirlineLogoWrap>
          <img src={`${imgPath}airLogo_UA.png`} alt='United Airlines' width='25' height='25' />
          <Text p={'0 6px'} fontSize={0} color='text.light'>
            United
          </Text>
        </AirlineLogoWrap>
        <AirlineLogoWrap>
          <img src={`${imgPath}airLogo_AA.png`} alt='American Airlines' width='25' height='25' />
          <Text p={'0 6px'} fontSize={0} color='text.light'>
            American
          </Text>
        </AirlineLogoWrap>
        <AirlineLogoWrap>
          <img src={`${imgPath}airLogo_DL.png`} alt='Delta Air Lines' width='25' height='25' />
          <Text p={'0 6px'} fontSize={0} color='text.light'>
            Delta
          </Text>
        </AirlineLogoWrap>
        <AirlineLogoWrap>
          <img src={`${imgPath}airLogo_AS.png`} alt='Alaska Airlines' width='25' height='25' />
          <Text p={'0 6px'} fontSize={0} color='text.light'>
            Alaska
          </Text>
        </AirlineLogoWrap>
      </TutorialAirlines>

      <Disclaimer color={'text.light'} fontSize={0} regular>
        You are not guaranteed one of these example airlines.
      </Disclaimer>
    </Wrapper>
  )
}
